/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Faqs } from "./FAQSData";
import { useLenis } from "./SmoothScroll";
import { Helmet } from "react-helmet-async";
const CitrusFAQs = () => {
  const [visibleCount, setVisibleCount] = useState(10);

  const loadMore = () => {
    setVisibleCount((prev) => prev + 10);
  };
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  return (
    <>
      <Helmet>
        <title>Imaging FAQs | Ultrasound, X-Ray, DEXA | Citrus County</title>
        <meta
          name="description"
          content="Have questions about imaging? Learn about ultrasound, nuclear medicine imaging, DEXA scans, X-ray services, and bone density tests at Citrus diagnostic center"
        />
        <meta
          name="keywords"
          content="FAQ
Ultrasound Imaging
Nuclear medicine imaging
Dexa Scan
X-Ray Imaging Center
Bone density test

"
        />
      </Helmet>
      <div className="flex justify-center flex-col items-center  md:pt-20 pt-14 xl:pt-32  text-[#ccc]">
        <h1 className="lg:text-[52px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  px-4 text-center capitalize w-full">
          frequently asked questions
        </h1>
        <div className="lg:w-[70%] w-[90%] mx-auto pt-20  leading-[34px] lg:pb-20 pb-10">
          <Box sx={{ width: "100%" }}>
            {Faqs.slice(0, visibleCount).map((faq, index) => (
              <Accordion
                key={index}
                elevation={0}
                disableGutters
                sx={{
                  borderBottom: "1px solid #fafaf6a4",
                  "&::before": { display: "none" },
                  boxShadow: "none",
                  backgroundColor: "transparent",
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <ArrowForwardIosIcon
                      sx={{ fontSize: 16, color: "white" }}
                    />
                  }
                  aria-controls={`panel${index}-content`}
                  id={`panel${index}-header`}
                  sx={{
                    paddingY: 3,
                    paddingX: 0,
                    fontWeight: "900",
                    "& .MuiAccordionSummary-content": {
                      margin: 0,
                      fontWeight: 900,
                    },
                  }}
                >
                  <Typography>
                    {" "}
                    <h2 className="xl:text-[20px] text-[18px] font-heading  leading-[1.4em] text-[#f5f5f5] font-normal">
                      {faq.question}
                    </h2>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ paddingX: 0, paddingBottom: 2 }}>
                  <Typography>
                    <div className="text-[#cccccc] text-[16px]  font-robout">
                      {faq.answer}
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>

          {/* Load More Button */}
          {visibleCount < Faqs.length && (
            <div className="flex justify-center items-center w-full mt-16">
              <button
                onClick={loadMore}
                className="px-8 py-1.5 rounded-3xl bg-white font-bold text-black hover:bg-black hover:border hover:text-[#fff] border border-[#ffffff5d] transition-all duration-300"
              >
                Read More
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CitrusFAQs;
